import axios from '../../plugins/axios.js';

export default {
  async getUserRoles() {
    return await axios.get('api/User/Roles');
  },
  async getPartnerIDByAffiliateEmail(email) {
    return await axios.get('api/Partner/GetPartnerIDByAffiliateEmail?email=' + email);
  },
};
